/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const DiscountCreatePage = lazyLoad(
  () => import('./index'),
  module => module.DiscountCreatePage
);
